<template>
  <div class="bussinessLead">
    <div class="bussinessLeadBig">
      <div class="bussinessLead_box">
        <h2>{{ info.name }}</h2>
        <p class="bussinessLead_box_mesg">
          {{info.remarks}}
        </p>
        <p class="bussinessLead_box_mor" @click="toPage">查看详情 ></p>
      </div>
      <img :src="info.value" alt="" :class="animalShow? 'imgSHow':''"/>
    </div>
  </div>
</template>
<script>
export default {
  name: "allMessage",
  props:{
    msg:Object,
    default:() =>({})
  },
  data() {
    return {
      info:{},
      animalShow: false
    };
  },
  
  watch:{
    msg:{
      handler(newval){
        this.info = newval
        this.animalShow = true
        setTimeout(()=> {
          this.animalShow = false
        }, 2001)
      },
      deep:true,
      immediate:true
    }
  },
  created() {
    // this.info = newval
  },
  methods:{
    toPage(){
      if(this.info.linkUrl){
        window.open(this.info.linkUrl, "_blank"); // 新窗口打开外链接
      }else{
        this.$message({
          message: '敬请期待！',
          type: 'warning'
        });
      }
    }
  },
};
</script>
<style scoped lang="less">
.bussinessLead {
  // margin-top: 23px;
  background: rgba(237, 250, 255, 0.59);
  height: 335px;
  display: flex;
  justify-content: center;
  .bussinessLeadBig {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      height: 294px;
      width: 599px;
      flex-shrink: 0;
    }
    .imgSHow {
      animation: change-color 2s 1;
    }
    @keyframes change-color {
      0%{
        opacity: 0;
      }
      100%{
        opacity: 1;
      }
    }
  }
  .bussinessLead_box {
    margin-right: 121px;

    h2 {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      margin-bottom: 19px;
    }
    .bussinessLead_box_mesg {
      font-size: 16px;
      color: #6e6e6e;
      margin-bottom: 38px;
      line-height: 32px;
    }
    .bussinessLead_box_mor {
      font-size: 16px;
      color: #009999;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeIndex/businessLead.vue